__turbopack_context__.v({
  "Button": "VWEwsa_Button",
  "Container": "VWEwsa_Container",
  "Disabled": "VWEwsa_Disabled",
  "ErrorText": "VWEwsa_ErrorText",
  "MembershipDetailsList": "VWEwsa_MembershipDetailsList",
  "MembershipDetailsWrapper": "VWEwsa_MembershipDetailsWrapper",
  "SmallText": "VWEwsa_SmallText",
  "Title": "VWEwsa_Title",
});
